import { Text } from "@mantine/core";

type Props = {
  homeScore: number | null;
  awayScore: number | null;
  primaryTeamLocation: "home" | "away";
};

export function MatchScore({
  homeScore,
  awayScore,
  primaryTeamLocation,
}: Props) {
  const scoreHome = homeScore || 0;
  const scoreAway = awayScore || 0;

  return (
    <Text size="sm" style={{ fontFamily: "monospace" }} miw={50}>
      {primaryTeamLocation === "home" ? scoreHome : scoreAway} -{" "}
      {primaryTeamLocation === "home" ? scoreAway : scoreHome}
    </Text>
  );
}
